import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer({ packing_house_process_id, container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/container/${container_id}`
    );
  },
  fetchUnassignedPackages({packing_house_process_id, container_id, package_group_id, filters}) {
    let route = `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/fetch_unassigned_packages/${container_id}/${package_group_id}`;
    if (filters) route = `${route}?${filters}`;
    return RequesterV1.get(route);
  },
  fetchPackingHouseProcess({packing_house_process_id}) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/fetch_packing_house_process`
    );
  },
  updatePackageGroup({
    packing_house_process_id,
    container_id,
    package_group_id,
    pg_code,
    comment,
    thermo_code,
    grouped_at,
    packages = []
  }) {
    return RequesterV1.patch(
      `/packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/container/${container_id}/package_group/${package_group_id}/update`,
      {
        package_group: { container_id, pg_code, comment, thermo_code, grouped_at },
        packages: packages
      }
    );
  },
  fetchPackageGroup({ packing_house_process_id, container_id, package_group_id }) {
    return RequesterV1.get(
      `/packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/container/${container_id}/package_group/${package_group_id}`
    );
  },
  fetchProducersOrganizations(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/fetch_producers_organizations/${container_id}`
    );
  },
  fetchExportProcessCropCategories(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/list_exporter_process_crop_categories/${container_id}`
    );
  },
  fetchExportProcessCropVarieties(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/list_exporter_process_crop_varieties/${container_id}`
    );
  },
  fetchExportProcessCropSizes(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/list_exporter_process_crop_sizes/${container_id}`
    );
  },
  fetchExportProcessBrands(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/list_exporter_process_brands/${container_id}`
    );
  },
  fetchExportProcessCropPackages(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/list_exporter_process_crop_packages/${container_id}`
    );
  }
};
